import React from 'react'
import {Link} from 'react-router-dom'
import '../scss/LocationList.css'

const LocationList = (props) => (
  <ul className={'location-list'}>
    {props.locations.map(location => (
      <li key={location.id}>
        <Link to={`/${props.evento.id}/location/${location.id}`}
          className={'location-list__item'}>
          {location.codigo}
          <div className={'location-list__description'}>
            {location.descripcion}
          </div>
        </Link>
      </li>
    ))}
  </ul>
)

export default LocationList



// WEBPACK FOOTER //
// ./src/components/LocationList.js